import { render } from "./EditorDocHead.vue?vue&type=template&id=743e7602&ts=true"
import script from "./EditorDocHead.vue?vue&type=script&lang=ts"
export * from "./EditorDocHead.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__